module.exports = __webpack_public_path__ + "baby.png";